module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/reverb-logo-circle-7e745d2fc92bccab8a7f6dc4fb9b61d1.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/reverb-logo-circle.svg
// module id = lw0h
// module chunks = 24